import { render, staticRenderFns } from "./paperTest.vue?vue&type=template&id=34b5a614&scoped=true&"
import script from "./paperTest.vue?vue&type=script&lang=js&"
export * from "./paperTest.vue?vue&type=script&lang=js&"
import style0 from "./paperTest.vue?vue&type=style&index=0&id=34b5a614&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b5a614",
  null
  
)

export default component.exports